import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { SuraCommonsUiModule } from '@surainvestments/sura-common-ui';
import { SharedModule } from 'src/app/shared/shared.module';
import { NavbarAccountButtonComponent } from './navbar-account-button.component';

@NgModule({
  imports: [
    CommonModule,
    MatButtonModule,
    OverlayModule,
    SuraCommonsUiModule,
    SharedModule
  ],
  exports: [NavbarAccountButtonComponent],
  declarations: [NavbarAccountButtonComponent],
  providers: [],
})
export class NavbarAccountButtonModule { }
